import {Pipe, PipeTransform} from '@angular/core';
import {ScheduleChipType} from 'src/app/projects/challenge-builder/shared/cb-schedule-chip.component';

@Pipe({
  name: 'scheduleChipType',
  standalone: true,
})
export class ScheduleChipTypePipe implements PipeTransform {
  transform(schedule: string): ScheduleChipType {
    return (schedule as ScheduleChipType) || null;
  }
}
